export default {
  allStates: 'Alle Status',
  zeroStates: '0 Status sind ausgewählt',
};
